export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refPersonType"].includes(field?.key);
            },
            inputPropField: ({ data }) => {
                return { disabled: data.current > 0 ? true : false };
            },
        },
        {
            check: ({ field }) => {
                return ["idCard"].includes(field?.key);
            },
            inputPropField: ({ data, modelRef }) => {
                return {
                    "onUpdate:value": (value) => {
                        modelRef.idCard = value;
                        modelRef.username = value;
                    },
                    disabled: data.current > 0 ? true : false,
                };
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refTitle",
                    "birthDate",
                    "refNationality",
                    "refRace",
                    "refGender",
                    "firstNameTh",
                    "email",
                    "lastNameTh",
                    "mobile",
                    "refCompanyType",
                    "companyNameTh",
                    "registerCapital",
                    "shareholdingTh",
                    "registerDate",
                    "idLine",
                    "refEducation",
                    "refMainOccupation",
                    "refSecondOccupation",
                    "refSameAddressType",
                    "addresses.0.noTh",
                    "addresses.0.soiTh",
                    "addresses.0.roadTh",
                    "addresses.0.mooTh",
                    "addresses.0.refProvince",
                    "addresses.0.refAmphur",
                    "addresses.0.refTambon",
                    "addresses.0.postCode",
                    "addresses.1.noTh",
                    "addresses.1.soiTh",
                    "addresses.1.roadTh",
                    "addresses.1.mooTh",
                    "addresses.1.refProvince",
                    "addresses.1.refAmphur",
                    "addresses.1.refTambon",
                    "addresses.1.postCode",
                    "password",
                    "passwordConfirm",
                ].includes(field?.key);
            },
            inputPropField: ({ data }) => {
                return data.current > 0 ? { disabled: true } : {};
            },
        },
        {
            check: ({ field }) => {
                return ["attachmentDocs.0"].includes(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["addresses.0.refAddressType", "addresses.1.refAddressType"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            },
        },
        {
            check: ({ field }) => {
                return ["refCompanyType", "companyNameTh", "registerDate", "registerCapital", "shareholdingTh"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refPersonType?.key);
            },
        },
        {
            check: ({ field }) => {
                return ["acceptCondition", "labelAcceptCondition"].includes(field?.key);
            },
            visibleField: ({ data }) => {
                return data.current === 1;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "birthDate",
                    "refNationality",
                    "refRace",
                    "refReligion",
                    "refGender",
                    "refTitle",
                    "firstNameTh",
                    "lastNameTh",
                    "phone",
                    "idLine",
                    "refEducation",
                    "refMainOccupation",
                    "refSecondOccupation",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refPersonType?.key);
            },
        },
        {
            check: ({ field }) => {
                return ["expireDate"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refPersonType?.key);
            },
            inputPropField: ({ data }) => {
                return data.current > 0 ? { disabled: true } : {};
            },
        },
        {
            check: ({ field }) => {
                return [
                    "positionCode",
                    "register",
                    "refDepartment",
                    "refSubDepartment",
                    "addresses.0.tel",
                    "addresses.0.email",
                    "addresses.1.tel",
                    "addresses.1.email",
                    "userRoleRequests",
                    "refRegisterRole",
                    "refPosition",
                    "buttonLinkUser",
                ].includes(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },
        {
            check: ({ field }) => {
                return ["attachmentImageSignatures.0"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.attachmentSignatures?.[0]?.blob != null;
            },
        },
        {
            check: ({ field }) => {
                return ["spaceIdCard"].includes(field?.key);
            },
            visibleField: ({ modelRef, data }) => {
                return !("1" === modelRef.refPersonType?.key && "FISHERMAN" === data.registerType);
            },
        },
        {
            check: ({ field }) => {
                return ["sameAddressType"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !["1"].includes(modelRef.refSameAddressType?.key);
            },
        },
        {
            check: ({ field }) => {
                return ["addressContactTitle"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refSameAddressType?.key);
            },
        },
        {
            check: ({ field }) => {
                return ["attachmentImageIdCards.0"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.attachmentIdCards?.[0]?.blob != null;
            },
        },
    ];
};
